// Validation limits enforced by the backend Zod schemas in this package. Frontend imports
// from here so its client-side validation stays in lockstep with the backend without app
// code depending on `@performyard/models` directly.
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get MAX_COMPETENCY_LEVELS () {
        return _models.MAX_COMPETENCY_LEVELS;
    },
    get MAX_ROLE_DESCRIPTION_LENGTH () {
        return MAX_ROLE_DESCRIPTION_LENGTH;
    },
    get MAX_ROLE_NAME_LENGTH () {
        return _models.MAX_ROLE_NAME_LENGTH;
    }
});
const _models = require("@performyard/models");
const MAX_ROLE_DESCRIPTION_LENGTH = 5000;
